import { LineItemTypes } from '@parallel-fluidics/shared/constants';

export const getLineAmount = ({ quantity, unitPrice }) => (
  Number(quantity || 0) * Number(unitPrice || 0)
);

export const getProductServiceName = (item) => {
  if (item.type === LineItemTypes.PRODUCT) {
    return [item.sku && `[${item.sku}]`, item.name].filter(Boolean).join(' ');
  }
  return [
    item.partId ? `[${item.partId.substring(0, 6).toUpperCase()}]` : null,
    item.name,
  ].filter(Boolean).join(' ');
};

export const getLineDescription = (item) => ([
  item.description,
  item.bonding,
  item.leadtimeDays ? `Ships ${item.leadtimeDays} business days after PO is received` : null,
].filter(Boolean).join(' | '));

export const getPreparedEstimateValues = (values) => ({
  ...values,
  shipping: values.includeShipping ? values.shipping : null,
  lineItems: values.lineItems.map((item) => ({
    ...item,
    qboName: getProductServiceName(item),
    qboDescription: getLineDescription(item),
  })),
});

export const getEstimatePreviewRows = (values) => {
  const preparedValues = getPreparedEstimateValues(values);
  const itemRows = preparedValues.lineItems.map((item, index) => ({
    id: `line-item-${index}`,
    productOrService: item.qboName,
    description: item.qboDescription,
    quantity: Number(item.quantity || 0),
    rate: Number(item.unitPrice || 0),
    amount: getLineAmount(item),
  }));

  const shippingTotal = Number(preparedValues.shipping?.total || 0);
  return preparedValues.shipping ? [
    ...itemRows,
    {
      id: 'shipping',
      productOrService: 'Shipping',
      description: preparedValues.shipping?.displayName || '',
      quantity: 1,
      rate: shippingTotal,
      amount: shippingTotal,
    },
  ] : itemRows;
};

export const getEstimateTotal = (values) => (
  getEstimatePreviewRows(values).reduce((sum, row) => sum + row.amount, 0)
);
